import { Button, Text } from '@southfields-digital/mpxlive-components';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { StateType } from 'src/redux/reducers';
import {
  REQUEST_GET_MOS_STATUS,
  REQUEST_MOS_RESYNC_PLAYLIST,
  REQUEST_TOGGLE_MOS_AUTO_FETCH,
} from 'src/redux/reducers/mos';

const MosButtons = ({ alwaysShow = false }: { alwaysShow?: boolean }) => {
  const dispatch = useDispatch();

  const { data: playlists } = useSelector((state: StateType) => state.playlist.getAll);

  const mosId = useSelector((state: StateType) => state.rundown.detail.data?.externalReference);

  const { connected, autoFetch, statusLoading } = useSelector((state: StateType) => state.mos);

  // TODO: support individual playlists
  const mosPlaylist = playlists?.find((p) => p.externalReference);

  // The mosId is shared across all playlists in the same MOS rundown.
  const handleToggleAutoFetch = () => {
    if (!mosId) return;

    dispatch({
      type: REQUEST_TOGGLE_MOS_AUTO_FETCH,
      payload: { mosId, enabled: !autoFetch },
    });
  };

  const handlePullMos = () => {
    if (!mosId) return;

    dispatch({
      type: REQUEST_MOS_RESYNC_PLAYLIST,
      payload: { mosId, roId: mosPlaylist?.externalReference },
    });
  };

  // TODO: maybe fetch status periodically
  // Fetch MOS status on mount
  useEffect(() => {
    if (!mosId) return;

    dispatch({ type: REQUEST_GET_MOS_STATUS, payload: { mosId } });
  }, [dispatch, mosId]);

  // Only show MOS controls when there are MOS-linked playlists in this rundown.
  if (!mosId && !alwaysShow) return null;

  const disabled = !mosId;

  return (
    <div className="flex gap-2 w-full h-fit py-2 px-3 items-center flex-wrap">
      <div className="flex items-center gap-1.5">
        <span className={`inline-block w-2 h-2 rounded-full ${connected ? 'bg-emerald-400' : 'bg-red-400'}`} />
        <Text className="text-nowrap text-xs font-semibold">MOS</Text>
      </div>
      <div className="flex gap-1 ml-auto">
        <Button
          iconProps={{ icon: autoFetch ? 'link-horizontal-break' : 'link-horizontal' }}
          iconPosition="left"
          variant="muted"
          buttonSize="small"
          disabled={disabled || statusLoading || !connected}
          onClick={handleToggleAutoFetch}
        >
          <Text className={`text-nowrap text-xs font-semibold ${connected && autoFetch ? 'text-red-400' : 'text-emerald-400'}`}>
            {connected && autoFetch ? 'Disconnect' : 'Connect'}
          </Text>
        </Button>
        <Button
          iconProps={{ icon: 'file-arrow-down' }}
          iconPosition="left"
          variant="muted"
          buttonSize="small"
          disabled={disabled || autoFetch || statusLoading || !mosPlaylist}
          onClick={handlePullMos}
        >
          <Text className="text-nowrap text-xs font-semibold">Pull</Text>
        </Button>
      </div>
    </div>
  );
};

export default MosButtons;
